import { useEffect, useState } from "react";
import request from "project-config/services/request/request";
import { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { dateFormatter } from "project-config/utils/date-formatter";
import { CouponType } from "../constant";
import { useTabStore } from "../store/tab-store";
import { PaymentTypeCode } from "project-config/constants";

export interface ITransferRecordProps {
  couponNo: string;
  amount: number;
  couponUpdate: number;
  createDate: number;
  destName: string;
  destUserId: number;
  couponBefore?: number;
  amountIncome?: number;
  payMethod: number;
}

export function useTransferRecord() {
  const [transferData, setTransferData] = useState<ITransferRecordProps[]>([]);
  const { currentTab } = useTabStore();
  const { t } = useTranslation("coupon");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [currentCouponNo, setCurrentCouponNo] = useState<String | number>("");

  const isSubUserTransfer = (record: ITransferRecordProps) =>
    record.payMethod === PaymentTypeCode.SubUserTransfer;

  const transferColumns: ColumnsType<ITransferRecordProps> = [
    {
      title: t("coupon_transfer_sub_account"),
      dataIndex: "destName",
    },
    {
      title: t("coupon_transfer_in_num"),
      dataIndex: "amountIncome",
      render: (_, record) => (isSubUserTransfer(record) ? record.amount : "-"),
    },
    {
      title: t("coupon_transfer_num"),
      dataIndex: "amount",
      render: (value, record) => (isSubUserTransfer(record) ? "-" : value),
    },
    {
      title: t("coupon_transfer_before_num"),
      dataIndex: "couponBefore",
      render: (value, record) => (isSubUserTransfer(record) ? "-" : value),
    },
    {
      title: t("coupon_transfer_after_num"),
      dataIndex: "couponUpdate",
      render: (value, record) => (isSubUserTransfer(record) ? "-" : value),
    },
    {
      title: t("coupon_transfer_time"),
      dataIndex: "createDate",
      render: (row: number) => dateFormatter(row),
    },
  ];

  const freeCouponTransferColumns: ColumnsType<ITransferRecordProps> = [
    {
      title: t("coupon_transfer_sub_account"),
      dataIndex: "destName",
    },
    {
      title: t("coupon_transfer_time"),
      dataIndex: "createDate",
      render: (row: number) => dateFormatter(row),
    },
  ];

  useEffect(() => {
    if (!openDrawer) return;
    const getTransferOperate = async () => {
      const api =
        currentTab === CouponType.RenderingMember
          ? "/api/rendering/pay/recharge/queryUserVoucherRecords"
          : "/api/rendering/pay/recharge/queryUserCouponRecords";
      const { data, code } = await request.post(api, {
        couponNo: currentCouponNo,
      });
      if (code !== 200) return;
      const result = data
        .filter((p: ITransferRecordProps) => p.destUserId)
        .map((item: ITransferRecordProps) => {
          return Object.assign(item, {
            couponBefore: item.amount + item.couponUpdate,
          });
        });
      setTransferData([...result]);
    };
    getTransferOperate();
  }, [openDrawer, currentCouponNo, currentTab]);

  return {
    transferColumns,
    freeCouponTransferColumns,
    transferData,
    openDrawer,
    setOpenDrawer,
    setCurrentCouponNo,
  };
}
